import { render, staticRenderFns } from "./EdmList.vue?vue&type=template&id=b3869b7c&scoped=true"
import script from "./EdmList.vue?vue&type=script&lang=js"
export * from "./EdmList.vue?vue&type=script&lang=js"
import style0 from "./EdmList.vue?vue&type=style&index=0&id=b3869b7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3869b7c",
  null
  
)

export default component.exports